"use client"

import { useEffect, useState } from "react"

const TIME_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Phnom_Penh",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
})

export function CambodiaTime() {
    const [time, setTime] = useState("--:--")

    useEffect(() => {
        const updateTime = () => setTime(TIME_FORMATTER.format(new Date()))
        updateTime()
        const interval = window.setInterval(updateTime, 1000)

        return () => window.clearInterval(interval)
    }, [])

    return <span className="tabular-nums">{time}</span>
}
